import { useQuery } from "@apollo/client";

export default (QUERY, params = {}) => useQuery(QUERY, params);
